import { UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class DateInputErrorStateMatcher implements ErrorStateMatcher {
  public isErrorState(control: UntypedFormControl | null): boolean {
    return control && control.invalid;
  }
}
